import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

const AdCardHolder = styled.div`
  background: ${Colors.snow};
  border: 1px solid ${Colors.border};
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &.is-skeleton {
    cursor: default;
    pointer-events: none;
  }
  &.is-skeleton:hover {
    box-shadow: none;
  }

  .thumbnail {
    position: relative;
    height: 180px;
    background: ${Colors.background};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &.clickable {
      cursor: pointer;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .select-checkbox {
      position: absolute;
      top: 8px;
      left: 8px;
      background: ${Colors.snow};
      padding: 2px;
      border-radius: 2px;
    }

    /* Stands in for the image when a dynamic ad has no preview thumbnail.
       .thumbnail already centers its children. */
    .thumbnail-fallback {
      font-size: 48px;
      color: ${Colors.primaryAccent};
    }

    .type-icon {
      position: absolute;
      top: 8px;
      right: 8px;
      color: ${Colors.primaryAccent};
      background: ${Colors.snow};
      padding: 4px;
      border-radius: 4px;
      font-size: 14px;
    }

    .drag-handle {
      position: absolute;
      top: 8px;
      right: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1890ff;
      background: ${Colors.snow};
      padding: 4px 6px;
      border-radius: 4px;
      cursor: grab;
      touch-action: none;
      z-index: 1;
    }

    .drag-handle:active {
      cursor: grabbing;
    }

    .status-tag {
      position: absolute;
      bottom: 8px;
      left: 8px;
      margin: 0;
      font-size: 10px;
      font-weight: 600;
      line-height: 18px;
    }

    .dimensions-tag {
      position: absolute;
      bottom: 8px;
      right: 8px;
      background: rgba(0, 0, 0, 0.55);
      color: ${Colors.white};
      font-size: 11px;
      line-height: 16px;
      padding: 1px 6px;
      border-radius: 3px;
    }

    .thumbnail-skeleton {
      width: 80%;
    }
  }

  .info {
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;

    .title-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 8px;

      .name {
        font-size: 13px;
        color: ${Colors.textStrong};
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .menu-icon {
        color: ${Colors.textMuted};
        cursor: pointer;

        &:hover {
          color: ${Colors.textStrong};
        }
      }
    }

    .meta {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: ${Colors.textMuted};
    }

    .card-actions {
      display: flex;
      gap: 8px;
      margin-top: 2px;

      button {
        color: #1890ff;
        border-color: #91d5ff;
      }

      .action-added {
        color: #52c41a;
        border-color: #b7eb8f;
        background: ${Colors.tintSuccess};
      }
    }
  }

  /* Fixed card height in grid view so varying image sizes never break the row.
     The image is letterboxed (object-fit: contain) within the fixed thumbnail box. */
  &.grid-view {
    height: 264px;

    &.has-actions {
      height: 296px;
    }
  }

  &.list-view {
    flex-direction: row;
    align-items: center;
    height: auto;

    .thumbnail {
      width: 80px;
      height: 80px;
      flex-shrink: 0;
    }

    .info {
      flex: 1;
    }
  }
`

export default AdCardHolder
